export function safeNext(next: string | null): string | null {
  return next && next.startsWith('/') && !next.startsWith('//') ? next : null;
}

export function addressHref(url: string, next: string | null): string {
  const path = safeNext(next);
  if (!path) return url;
  const target = new URL(url);
  target.searchParams.set('next', path);
  return target.toString();
}
